import { BasePayload } from "@src/core/api/payload-mapper";
import { Base } from "@src/core/models/base";

export const mockSingle = (mockFunction: () => Base): (() => BasePayload) => {
  return () => {
    const attributes = mockFunction();

    return {
      id: attributes.id,
      attributes,
      type: "mock",
    };
  };
};

export const mockList = (
  mockFunction: () => Base,
  amount = 4
): (() => BasePayload[]) => {
  return () => [...Array(amount)].map(() => mockSingle(mockFunction)());
};
